import './estilos/tokens.css';
import './estilos/base.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { db } from './lib/db.js';
import { construirSemilla } from './lib/semilla.js';
import { pedirPersistencia } from './lib/sincronizacion.js';

/**
 * Carga los datos iniciales la primera vez que se abre la app.
 * Si ya hay categorías, no toca nada: los datos del usuario mandan.
 */
async function prepararBase() {
  const yaHayDatos = await db.categorias.count();
  if (yaHayDatos > 0) return false;

  const { entidades, categorias, cuentas } = construirSemilla();
  await db.transaction('rw', db.entidades, db.categorias, db.cuentas, async () => {
    await db.entidades.bulkAdd(entidades);
    await db.categorias.bulkAdd(categorias);
    await db.cuentas.bulkAdd(cuentas);
  });
  return true;
}

/**
 * Pide al navegador que no borre los datos.
 *
 * Por defecto IndexedDB es "mejor esfuerzo": bajo presión de almacenamiento el
 * navegador puede borrar TODO el origen de un golpe, sin avisar. Para datos
 * financieros eso es inaceptable, así que se pide permiso permanente apenas
 * arranca. Chrome lo concede si la app está instalada o si la usas seguido.
 */
async function asegurarDatos() {
  const r = await pedirPersistencia();
  if (r.soportado && !r.concedido) {
    console.warn(
      'El navegador no garantizó la persistencia de los datos. ' +
        'Instala la app para que lo haga, y exporta un respaldo de vez en cuando.'
    );
  }
  return r;
}

const [primeraVez, persistencia] = await Promise.all([
  prepararBase(),
  asegurarDatos(),
]);

mount(App, {
  target: document.getElementById('app'),
  props: { primeraVez, persistencia },
});
